export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'v_expenseBizType',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: that.$l('form_label_expenseBizType') || '业务类型',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'expenseName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    title: that.$l('form_label_expenseName') || '中文名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'expenseNameEn',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    title: that.$l('form_label_expenseNameEn') || '英文名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'v_expenseType',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: that.$l('form_label_expenseType') || '费用项目',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'remark',
    headerAlign: 'center',
    align: 'left',
    width: 300,
    title: that.$l('form_label_remark') || '备注说明',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    width: 80,
    align: 'center',
    slots: {default: 'status'},
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createDate',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
